import { createSelector } from "reselect";
import _ from "lodash";

const createSelectors = parentReducer => {
    return new (class {
        selectUsers = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserTotalWidget_reducer"];
            return reducer.users;
        };
        selectjobPacks = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserTotalWidget_reducer"];
            return reducer.jobPacks;
        };
        selectVehicles = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserTotalWidget_reducer"];
            return reducer.qr;
        };
        selectBuild = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserTotalWidget_reducer"];
            return reducer.build_data;
        };
        selectEnvBuild = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserTotalWidget_reducer"];
            return reducer.env_build;
        };
        selectBuildStatus = createSelector(
            [this.selectBuild, this.selectEnvBuild],
            (dbBuild = false, envBuild = false) => {
                if (dbBuild && envBuild) {
                    return compareVersion(
                        envBuild,
                        dbBuild.dashboard_client_build
                    ) === 0
                        ? "good"
                        : "bad";
                } else return "bad";
            }
        );
        selectAllAreas = store => {
            const pageReducer = store[parentReducer];
            const reducer =
                pageReducer["UserTotalWidget_reducer"];
            return reducer.areas;
        };
        selectAllDepartments = store => {
            const pageReducer = store[parentReducer];
            const reducer =
                pageReducer["UserTotalWidget_reducer"];
            return reducer.departments;
        };
        selectProfile = store => {
            const reducer = store["UserProfile_reducer"];
            let userInfo = reducer.user;
            return userInfo.profile;
        };
        selectDept = createSelector (
            [this.selectProfile],
            
            (profile = false) => {
                if(profile)
                {
                    return profile.departments
                }
                else return null
            }
        )
        selectAreas = createSelector (
            [this.selectProfile],
            (profile = false) => {
                if(profile)
                {
                    return profile.areas
                }
                else return null
            }
        )
        selectDashDetails = createSelector(
            [   
                this.selectUsers,
                this.selectAllAreas, 
                this.selectAllDepartments, 
                this.selectAreas, 
                this.selectDept,
            ],
            (
                users = false,
                allAr = false, 
                allDept = false,
                userAreas = false, 
                userDepts = false) => {
                if (users) {
                //get users belonging to logged in user areas & depts    
                let allAreas = allAr && Object.values(allAr).map((e)=> { return e })
                let allDepartments = allDept && Object.values(allDept).map((e)=> { return e })
                
                if(userAreas === false)
                {
                    userAreas = allAreas
                }
                if(userDepts === false)
                {
                    userDepts = allDepartments
                }
                let validationArea = []
                let validationDept = []
               
                
                let totalEmployees = _.compact(
                        Object.keys(users).map(e => {
                            let refArray = []
                            let uid = e;
                            let fname =
                                _.get(users[e], "profile.first_name") || "N/A";
                            let lname =
                                _.get(users[e], "profile.last_name") || "N/A";
                            let deleted =
                                _.get(users[e], "profile.deleted") || false;
                            let areas = 
                                _.get(users[e], "profile.areas") || null
                            let departments = 
                                _.get(users[e], "profile.departments") || null 

                            if(areas === null ){
                                validationArea = _.intersection(allAreas,userAreas)
                            }else{
                                validationArea = _.intersection(areas,userAreas)
                            }

                            if(departments === null){
                                validationDept = _.intersection(allDepartments,userDepts)
                            }else {
                                validationDept = _.intersection(departments,userDepts)
                            } 

                            if (!deleted && validationArea.length !== 0 && validationDept.length !== 0) {
                                refArray.push({ uid, user_name: `${fname} ${lname}` })
                                return { uid, user_name: `${fname} ${lname}` };
                                    
                            } else return null;
                        })
                    );
                    return Object.keys(totalEmployees).length;
                } else return false;
            }
        );
    })();
};
function compareVersion(v1, v2) {
    if (typeof v1 !== "string") return false;
    if (typeof v2 !== "string") return false;

    v1 = v1.split(".");
    v2 = v2.split(".");
    const k = Math.min(v1.length, v2.length);
    for (let i = 0; i < k; ++i) {
        v1[i] = parseInt(v1[i], 10);
        v2[i] = parseInt(v2[i], 10);
        if (v1[i] > v2[i]) return 1;
        if (v1[i] < v2[i]) return -1;
    }
    return v1.length === v2.length ? 0 : v1.length < v2.length ? -1 : 1;
}
export default createSelectors;
